import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import {IncomFreqency,IncomType,childIncomeTypeList} from './schoolLunchBreakfastModal';
import Draft from './draft.js';
class AddChildIncome extends Component {
    constructor(props){
        super(props);
        this.state={
            'hasError':false
        }
        this.validateStudents=this.validateStudents.bind(this)
        this.childComponentRef = React.createRef();
    }
    validateStudents=()=>{
        let studentError=true;
        let _studentList=[]
        _studentList=(this.props.lunchObj.studentList.filter((stu)=>{
            return stu.isSelected===true && stu.liveUnderFosterCare===false
        }))
        studentError=_studentList.every((student,s)=>{
            return student.income.every((inc)=>{
                return inc.source!='' && inc.frequency!='' && parseFloat(inc.amount===''?0:inc.amount)>0
            })
        });
        let childError=true
        childError= this.props.lunchObj.childList.every((student,s)=>{
            return student.income.every((inc)=>{
                return inc.source!='' && inc.frequency!='' && parseFloat(inc.amount===''?0:inc.amount)>0
            })
        })

        if(studentError && childError ){
            return true
        }
        return false
    }

render(){
    return(
        <div>
        
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><Trans>The next few questions are about your children's income</Trans></p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                <p><Trans>Some common sources of income for children are</Trans>:</p>
                    <ul>
                        <li><p><Trans>a full-time or part-time job,</Trans></p></li>
                        <li><p><Trans>Supplemental Security Income (SSI), if the child is disabled, Social Security benefits for children of a disabled, retired, or deceased parent,</Trans></p></li>
                        <li><p><Trans>money regularly received from extended family or friends outside the household, or</Trans></p></li>
                        <li><p><Trans>money from a pension, annuity, or trust</Trans></p></li>
                    </ul>
                    <p><strong><Trans>Do not include infrequent earnings, such as income from occasional baby-sitting or mowing lawns</Trans>.</strong></p>
                </div>
            </div>
             <div className="row">
                <div className="col-xs-12">
                {
                    this.props.lunchObj.studentList.map((student,s)=>{
                        if(student.isSelected===true && student.liveUnderFosterCare===false){
                            return(
                                <div className="row">
                                    <div className="col-md-9">
                                        <h5 className="color-5"><strong>{student.lname+' '+student.fname}</strong></h5>
                                    </div>
                                    {
                                        student.income.length<3?<div className="col-md-2">
                                    <button type="button" className="btn-social btn-twitter-link" data-midx={s} style={{margin:'0px'}} onClick={(e)=>{
                                        let midx=e.target.getAttribute('data-midx');
                                        this.props.addIncome(midx,'studentList')
                                        this.childComponentRef.current.formatDraftReqObj();
                                    }}><i className="fa fa-plus"></i> <Trans>Add income</Trans></button>
                                    </div>:null
                                    }
                                    
                                    <div className="col-md-12 device-select-style" style={{paddingLeft:'30px'}}>                                        
                                        {
                                            student.income.map((inc,i)=>{
                                                return (<div className="row">
                                                    <div className="col-md-4" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'source-stu-'+s+'-'+i} data-fname={'source'} data-midx={s} data-sidx={i} 
                                                    value={inc.source}
                                                    onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'studentList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {
                                                            (() => {
                                                                 const selectedSources = student.income
                                                                    .map(v => v.source)
                                                                    .filter(src => src !== '');

                                                                return childIncomeTypeList.map((incType, t) => {
                                                                    const isDisabled =
                                                                        selectedSources.includes(incType) && incType !== inc.source;

                                                                    return (
                                                                        <option key={t} value={incType} disabled={isDisabled}>
                                                                            <Trans>{incType}</Trans>
                                                                        </option>
                                                                    );
                                                                });
                                                            })()
                                                        }
                                                    </select>
                                                    </div>
                                                    <div className="col-md-2" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'frequency-stu-'+s+'-'+i} data-fname={'frequency'} 
                                                    data-midx={s} 
                                                     data-sidx={i} value={inc.frequency} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'studentList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {                                                            
                                                            IncomFreqency.map((freq,f)=>{
                                                                return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                            })
                                                        }
                                                    </select></div>
                                                    <div className="col-md-2">
                                                    <input className="form-control" name={'amount-stu-'+s+'-'+i} data-fname={'amount'} data-midx={s} data-sidx={i}
                                                    type="number" value={inc.amount} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'studentList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button type="button" data-midx={s} data-sidx={i} 
                                                        className="btn-social btn-twitter-link color-1" style={{margin:'0px'}} onClick={(e)=>{
                                                            let midx=e.target.getAttribute('data-midx');
                                                            let sidx=e.target.getAttribute('data-sidx');
                                                            this.props.onDeleteIncome(midx,'studentList',sidx);
                                                            this.childComponentRef.current.formatDraftReqObj();
                                                        }}><i className="fa fa-trash"></i> <Trans>Delete</Trans></button>
                                                    </div>
                                                </div>)
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        }
                    })
                }
                {
                    this.props.lunchObj.childList.map((child,s)=>{
                        return(
                                <div className="row">
                                    <div className="col-md-9">
                                        <h5 className="color-5"><strong>{child.lname+' '+child.fname}</strong></h5>
                                    </div>
                                    {
                                        child.income.length<3?
                                        <div className="col-md-2">
                                    <button type="button" className="btn-social btn-twitter-link" data-midx={s} style={{margin:'0px'}} onClick={(e)=>{
                                        let midx=e.target.getAttribute('data-midx');
                                        this.props.addIncome(midx,'childList')
                                        this.childComponentRef.current.formatDraftReqObj();
                                    }}><i className="fa fa-plus"></i> <Trans>Add income</Trans></button>
                                    </div>:null

                                    }
                                    
                                    <div className="col-md-12 device-select-style" style={{paddingLeft:'30px'}}> 
                                        {
                                            child.income.map((inc,i)=>{
                                                return (<div className="row">
                                                    <div className="col-md-4" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'source-ch-'+s+'-'+i} data-fname={'source'} data-midx={s} data-sidx={i}
                                                     value={inc.source} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'childList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {
                                                            (() => {
                                                                 const selectedSources = child.income
                                                                    .map(v => v.source)
                                                                    .filter(src => src !== '');

                                                                return childIncomeTypeList.map((incType, t) => {
                                                                    const isDisabled =
                                                                        selectedSources.includes(incType) && incType !== inc.source;

                                                                    return (
                                                                        <option key={t} value={incType} disabled={isDisabled}>
                                                                            <Trans>{incType}</Trans>
                                                                        </option>
                                                                    );
                                                                });
                                                            })()
                                                        }
                                                        
                                                    </select>
                                                    </div>
                                                    <div className="col-md-2" style={{paddingBottom:'10px'}}>
                                                    <select className="form-control" name={'frequency-ch-'+s+'-'+i} data-fname={'frequency'} data-midx={s} 
                                                   data-sidx={i} value={inc.frequency} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'childList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} >
                                                        <option></option>
                                                        {                                                            
                                                            IncomFreqency.map((freq,f)=>{
                                                                return <option key={f} value={freq.value}>{freq.text}</option>
                                                            })
                                                        }
                                                    </select></div>
                                                    <div className="col-md-2">
                                                    <input className="form-control" name={'amount-ch-'+s+'-'+i} data-fname={'amount'} data-midx={s} data-sidx={i} 
                                                    type="number" value={inc.amount} onChange={(e)=>{
                                                        let midx=e.target.getAttribute('data-midx');
                                                        let sidx=e.target.getAttribute('data-sidx');
                                                        this.props.onFieldValueChange(midx,'childList',sidx,e.target.getAttribute('data-fname'),e.target.value);
                                                    }} />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button type="button" data-midx={s} data-sidx={i} 
                                                        className="btn-social btn-twitter-link color-1" style={{margin:'0px'}} onClick={(e)=>{
                                                            let midx=e.target.getAttribute('data-midx');
                                                            let sidx=e.target.getAttribute('data-sidx');
                                                            this.props.onDeleteIncome(midx,'childList',sidx);
                                                            this.childComponentRef.current.formatDraftReqObj();
                                                        }}><i className="fa fa-trash"></i> <Trans>Delete</Trans></button>
                                                    </div>
                                                </div>)
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                }
                </div>
            </div> 
            <div className="row">
                <div className="col-md-12">
                    <p>
                    { (!this.validateStudents()) && this.state.hasError? <span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }</p>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(8)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        if(this.validateStudents()){
                            this.props.jumpToStep(10);
                        }else{
                            this.setState({hasError:true})
                        }                        
                    }}><Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} isDistrict={this.props.isDistrict}/>
                </div>
            </div>
        </div>
    )
}
}
export default AddChildIncome;


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/addChildIncome.jsx